import { Link } from 'react-router-dom'
import { PlusCircleIcon } from 'lucide-react'
import { useBrands } from '@/lib/BrandsProvider'
import { Button } from '@/components/ui/button'

export default function NoBrandSelected() {
    const { brands } = useBrands()

    if (brands.length === 0) {
        return (
            <div className="flex items-center justify-center h-full">
                <div className="text-center max-w-md mx-auto p-6">
                    <h2 className="text-2xl font-semibold text-gray-700">No Brands Configured</h2>
                    <p className="text-gray-500 mt-3 mb-6">
                        To get started, you'll need to set up your first brand. This will allow you to manage campaigns, content, and use our AI tools.
                    </p>
                    <Link to="/onboarding">
                        <Button className="gap-2">
                            <PlusCircleIcon className="h-5 w-5" />
                            Set up your brand
                        </Button>
                    </Link>
                </div>
            </div>
        )
    }

    return (
        <div className="flex items-center justify-center h-full">
            <div className="text-center">
                <h2 className="text-xl font-semibold text-gray-700">No Brand Selected</h2>
                <p className="text-gray-500 mt-2">
                    Please select a brand from the sidebar to view the dashboard
                </p>
            </div>
        </div>
    )
} 